import mainApi from "./mainApi";

export const getTexts = async (locale) => {
    const {data} = await mainApi.get(`/textos/${locale}`);
    return data;
}